import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/higienizacion/vector_negro.png")